module.exports = __webpack_public_path__ + "assets/img/ic-message-hover.60a3ca21.svg";